<div class="card-body" *ngIf="{warningModalMessages: warningModalMessages$ | async} as context">
	<div class="preview-container">
		<button *ngIf="context.warningModalMessages" class="btn btn-sm btn-warning create-button" (click)="create()">Create</button>

		<dx-data-grid *ngIf="context.warningModalMessages" [dataSource]="context.warningModalMessages" height="100%">
			<dxo-selection mode="none"></dxo-selection>
			<dxo-filter-row [visible]="true"></dxo-filter-row>

			<dxi-column dataField="name"></dxi-column>
			<dxi-column dataField="fromLinkTemplates" caption="From Link Templates" [calculateCellValue]="fromLinkTemplateCellValue"></dxi-column>
			<dxi-column dataField="toLinkTemplates"  caption="To Link Templates" [calculateCellValue]="toLinkTemplateCellValue"></dxi-column>
			<dxi-column dataField="startDate"></dxi-column>
			<dxi-column dataField="endDate"></dxi-column>
			<dxi-column dataField="messageHtml"></dxi-column>

			<dxi-column cellTemplate="actionsCellTemplate" [allowResizing]="false" [fixed]="true" fixedPosition="right" dataType="string" width="210px"></dxi-column>

			<div class="actions-cell" *dxTemplate="let d of 'actionsCellTemplate'">
				<button class="btn btn-sm btn-warning action-button" (click)="view(d.data)">View</button>
				<button class="btn btn-sm btn-warning action-button" (click)="delete(d.data.id)">Delete</button>
				<button class="btn btn-sm btn-warning action-button" (click)="update(d.data)">Update</button>
			</div>
		</dx-data-grid>
		<div *ngIf="!context.warningModalMessages && loading" class="select-message">Loading...</div>
	</div>
</div>

<message-modal></message-modal>

<warning-modal-message-create-modal></warning-modal-message-create-modal>
